// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".red[data-v-acac1550] {\n  color: #ed4014;\n}\n.table .el-image[data-v-acac1550] {\n  width: auto !important;\n  height: 30px !important;\n}\n.table[data-v-acac1550] ::v-deepel-image__inner,\n.table .el-image__placeholder[data-v-acac1550],\n.table .el-image__error[data-v-acac1550] {\n  width: auto !important;\n}\n.info[data-v-acac1550] {\n  width: 82%;\n}", ""]);
// Exports
module.exports = exports;
